// Object contrustor from external Javascript file imported in index.html from public/js/dbsign.js
const DBsignFuncs: any = window.DBsign;

class DBsignService {
  version: string = 'N/A';
  dbsign: any = null;
  initTimeMs: number = 0;
  initSuccess: boolean = false;
  onReady: () => void = () => {};
  onInitFailure: () => void = () => {};

  init(onReady: () => void = () => {}, onInitFailure: () => void = () => {}) {
    this.onReady = onReady;
    this.onInitFailure = onInitFailure;

    this.dbsign = new DBsignFuncs();
    this.initTimeMs = Date.now();
    this.dbsign.init(this.handleJswsReady, this.handleJswsInitFailure);
    this.version = this.dbsign.jsws.DBS_GetVersion();
  }

  handleJswsReady = () => {
    this.initTimeMs = Date.now() - this.initTimeMs;
    this.initSuccess = true;
    this.version = this.dbsign.jsws.DBS_GetVersion();
    console.log('onJswsReady():', this.version);
    this.onReady();
  };

  handleJswsInitFailure = () => {
    this.initTimeMs = Date.now() - this.initTimeMs;
    this.initSuccess = false;
    this.onInitFailure();
  };
}

export default DBsignService;
